/* eslint-disable no-nested-ternary */
import React from "react";
import { addThemeDefault } from "../core/Themer";
import Avatar from "@material-ui/core/Avatar";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { makeStyles } from "@material-ui/styles";
import withStyles from "@material-ui/core/styles/withStyles";
import { withRouter } from "react-router-dom";
import withWorkflow from "./withWorkflow";

addThemeDefault({
  overrides: {
    MuiStepConnector: {
      alternativeLabel: {
        color: "red",
        top: "20px",
        position: "absolute"
      },
      lineHorizontal: {
        borderTopWidth: "2px"
      },
      line: {
        color: "#879baa"
      }
    }
  }
});

const useStyles = makeStyles(() => ({
  root: {
    padding: 1,
    background: "inherit"
  }
}));

const stepLabelStyle = {
  label: {
    color: "#999",
    transform: "scale(0.85)",
    marginTop: "2px"
  },
  alternativeLabel: {
    marginTop: "2px !important"
  },
  active: {
    color: "white !important"
  },
  completed: {
    color: "#999 !important"
  }
};

const stepIconStyle = theme => ({
  avatar: {
    backgroundColor: ({ active, completed, error }) =>
      active
        ? theme.palette.primary.light
        : completed
        ? theme.palette.secondary.dark
        : error
        ? theme.palette.error.dark
        : theme.palette.primary.dark,
    width: "unset",
    height: "unset",
    padding: "8px"
  }
});

const StepIcon = withStyles(stepIconStyle, { name: "LcStepIcon" })(
  ({
    colors: { active, completed, error, disabled } = {
      active: "#EEE",
      completed: "#EEE",
      error: "red",
      disabled: "#999"
    },
    completedIcon = faCheck,
    ...props
  }) => {
    const color = props.active
      ? active
      : props.completed
      ? completed
      : props.error
      ? error
      : disabled;

    const icon = props.completed ? completedIcon : props.icon;

    return (
      <Avatar className={props.classes.avatar}>
        <FontAwesomeIcon icon={icon} size="sm" style={{ color }} />
      </Avatar>
    );
  }
);

const WorkflowProgressTracker = ({
  steps,
  stepInfo,
  getActiveStep,
  orientation = "vertical",
  alternativeLabel = false,
  classes
}) => {
  const stepperClasses = useStyles();

  const [activeStepKey] = getActiveStep(true);
  if (activeStepKey === undefined) return null;

  const filteredSteps = steps.filter(step => !(stepInfo[step] || {}).hideNav);
  let activeStepIdx = filteredSteps.indexOf(activeStepKey);
  let checkStep = activeStepKey;

  while (activeStepIdx === -1) {
    checkStep = stepInfo[checkStep].prev;
    activeStepIdx = filteredSteps.indexOf(checkStep);
  }

  return (
    <Stepper
      activeStep={activeStepIdx}
      orientation={orientation}
      alternativeLabel={alternativeLabel}
      classes={stepperClasses}
    >
      {filteredSteps.map(step => (
        <Step key={step}>
          <StepLabel
            StepIconComponent={StepIcon}
            StepIconProps={{ icon: stepInfo[step].icon }}
            classes={classes}
          >
            {stepInfo[step].label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default withRouter(
  withWorkflow(
    withStyles(stepLabelStyle, { name: "LcWorkflowProgressTracker" })(
      WorkflowProgressTracker
    )
  )
);
